import { config } from "../config";

export function getClerkConsumerPublishableKey(): string {
  return (
    config.CLERK_CONSUMER_PUBLISHABLE_KEY ||
    config.VITE_CLERK_CONSUMER_PUBLISHABLE_KEY ||
    ""
  ).trim();
}
